import { render, staticRenderFns } from "./AppCustomizer.vue?vue&type=template&id=7038031c&scoped=true"
import script from "./AppCustomizer.vue?vue&type=script&lang=js"
export * from "./AppCustomizer.vue?vue&type=script&lang=js"
import style0 from "./AppCustomizer.vue?vue&type=style&index=0&id=7038031c&prod&lang=scss"
import style1 from "./AppCustomizer.vue?vue&type=style&index=1&id=7038031c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038031c",
  null
  
)

export default component.exports